import { RootState } from '@modules/App/redux/store';
import { ResponsesActivityDataItem } from '@modules/HappinessModule/interfaces/ResponsesActivityDataItem';
import { AsyncData } from '@shared/interfaces/asyncData';

export const userHappinessDataSelector = (state: RootState): AsyncData<ResponsesActivityDataItem[]> =>
  state.happiness.userHappinessPage.userHappinessData;
